import { NavLink } from "react-router-dom";

const tabs = [
  { to: "/", label: "Live", icon: PulseIcon, end: true },
  { to: "/schedule", label: "Schedule", icon: CalendarIcon, end: false },
  { to: "/leagues", label: "Leagues", icon: TrophyIcon, end: false },
];

/**
 * Sidebar is desktop-only (`hidden md:flex`) and the top bar's nav links are
 * also `hidden md:flex` — without this, phone users have no way to move
 * between Live / Schedule / Leagues at all. This is the mobile equivalent of
 * the sidebar, pinned to the bottom of the viewport (standard mobile
 * ergonomics — thumb reach).
 */
export function MobileTabBar() {
  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 glass border-t border-base-600 pb-[env(safe-area-inset-bottom)]"
      aria-label="Primary"
    >
      <div className="flex items-stretch justify-around h-16">
        {tabs.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 flex-1 text-[11px] font-medium transition-colors ${
                isActive ? "text-emerald" : "text-ink-500"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon className={`w-5 h-5 ${isActive ? "text-emerald" : "text-ink-500"}`} />
                {label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

function PulseIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 12h4l2-7 4 14 3-9 2 4h3" />
    </svg>
  );
}
function CalendarIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path strokeLinecap="round" d="M16 3v4M8 3v4M3 10h18" />
    </svg>
  );
}
function TrophyIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 21h8M12 17v4M7 4h10v4a5 5 0 01-10 0V4z" />
      <path strokeLinecap="round" d="M17 5h3a4 4 0 01-4 4M7 5H4a4 4 0 004 4" />
    </svg>
  );
}
